import React, { useEffect, useState } from "react";

import { getList } from "services/api/Api";

import { Cell, Pie, PieChart, ResponsiveContainer, Legend } from "recharts";

import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import CircleChartIndex from "../WidgetsSettings/CircleChartSettings/CircleChartIndex";

import ".././WidgetsSettings/CircleChartSettings/CircleChartSettings.less";
import { isActivePublicUser } from "../../../util/Scripts";

const CircleChart = ({ value, role }) => {
   const [listData, setListData] = useState([]);
   const [columnsList, setColumnsList] = useState([]);
   const [chartType, setChartType] = useState();

   const [data, setData] = useState({
      dataProvider: null
   });

   let showedData = [];
   let calculateData = {};

   useEffect(() => {
      getList(value.listId, 1, 10).then((res) => {
         const responseData = isActivePublicUser() ? res.data.getPublicList : res.data.default;
         setListData(responseData.data);
         setColumnsList(responseData.columns);

         responseData.data.forEach((data, i) => {
            if (calculateData[data[value.groupColumnTechName].value] === undefined) {
               calculateData[data[value.groupColumnTechName].value] = 1;
            } else {
               calculateData[data[value.groupColumnTechName].value] =
                  calculateData[data[value.groupColumnTechName].value] + 1;
            }
         });
         Object.keys(calculateData).forEach((key) => {
            showedData.push({
               name: key,
               value: calculateData[key]
            });
         });
         console.log(showedData);
         setData({
            ...data,
            dataProvider: showedData
         });
      });
   }, []);

   const chooseChartType = (value) => {
      if (value.chartType === "PieChartWithCustomizedLabel") {
         return (
            <Pie
               dataKey="value"
               data={data.dataProvider}
               cx="35%"
               cy="50%"
               innerRadius={60}
               outerRadius={80}
               fill="#003366"
               paddingAngle={5}
               label
            >
               {data.dataProvider.map((entry, index) => (
                  <Cell key={index} fill={COLORS[index % COLORS.length]} />
               ))}
            </Pie>
         );
      } else if (value.chartType === "PieChartWithPaddingAngle") {
         return (
            <Pie
               dataKey="value"
               data={data.dataProvider}
               cx="70%"
               cy="50%"
               startAngle={180}
               endAngle={0}
               innerRadius={60}
               outerRadius={80}
               fill="#003366"
               paddingAngle={5}
            >
               {data.dataProvider.map((entry, index) => (
                  <Cell key={index} fill={COLORS[index % COLORS.length]} />
               ))}
            </Pie>
         );
      } else if (value.chartType === "StraightAnglePieChart") {
         return (
            <Pie
               dataKey="value"
               startAngle={180}
               endAngle={0}
               data={data.dataProvider}
               outerRadius={80}
               fill="#003366"
               label
            />
         );
      }
   };

   const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

   return (
      <Widget
         className="Widget"
         role={role}
         extra={
            role === "OWNER" || role === "MODERATOR" ? (
               <SettingsModal
                  widgetName={value.name}
                  widgetId={value.id}
                  icon="setting"
                  deleteIcon="true"
                  children={
                     <CircleChartIndex value={value} columns={columnsList ? columnsList : []} />
                  }
               />
            ) : null
         }
      >
         {data.dataProvider ? (
            <div className={value.chartType}>
               <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                     {chooseChartType(value)}

                     <Legend className="recharts-default-legend" />
                  </PieChart>
               </ResponsiveContainer>
            </div>
         ) : null}
      </Widget>
   );
};

export default CircleChart;
